/*

Couldn't build with jpalette dependency.
https://github.com/jsrdescamps/jpalette

so copied v 1.0.4 into project

 */

export { default as Color } from './Color';
export { default as ColorMap } from './ColorMap';
